<div style="width: 100vw; height: 100vh; color: white; display: flex; flex-direction:column; align-items: center;justify-content: center;">
    <!-- <img style="animation: spin 1.6s linear infinite; width: 75px;" src="assets/images/logo/logo.svg" alt=""> -->
    <div class="spinner-border text-secondary" style="width: 3rem; height: 3rem;" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    <div><span style="font-size:20px; color: var(--primary);"><strong>{{message}}</strong></span></div>
    <!-- <img style="animation: spin 1.6s linear infinite; width: 75px;" src="assets/images/logo/loading2.svg" alt=""> -->
</div>